import { LoadingButton } from '@mui/lab'
import { Button } from '@mui/material'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { useSendEmailVerificationMutation } from 'app/redux/scribeApi'

import { BasicActionModal } from './BasicActionModal'

type Props = {
  open: boolean
  onClose: () => void
  authId: string
  email?: string
}

export const ResendVerification: React.FC<Props> = ({ open, onClose, authId, email }) => {
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()

  const [sendVerification, { isLoading }] = useSendEmailVerificationMutation()

  const handleSendVerification = async () => {
    try {
      await sendVerification(authId).unwrap()
      enqueueSnackbar(t('userProfile.actions.successfulResendVerification', { email }), {
        variant: 'success',
      })
    } catch (error) {
      enqueueSnackbar(t('userProfile.actions.errorResendVerification', { email }), {
        variant: 'error',
      })
    }
    onClose()
  }

  return (
    <BasicActionModal
      open={open}
      onClose={onClose}
      title={t('userProfile.info.resendVerificationEmail')}
      subtitle={t('userProfile.info.resendEmailConfirmation')}
      email={email}
      actions={
        <>
          <Button variant="outlined" onClick={onClose} data-testid="close-button">
            {t('global.dialog.cancel')}
          </Button>
          <LoadingButton
            variant="contained"
            loading={isLoading}
            onClick={handleSendVerification}
            type="submit"
            sx={{ ml: 2 }}
            data-testid="resend-button"
          >
            {t('userProfile.actions.resendVerification')}
          </LoadingButton>
        </>
      }
    />
  )
}
